import React from "react";
import { Route, Routes } from "react-router-dom";

import GeneralDisclosure21 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure21";
import GeneralDisclosure26 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure26";
import GeneralDisclosure27 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure27";
import GeneralDisclosure211 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure211";
import GeneralDisclosure22 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure22";
import GeneralDisclosure23 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure23";
import GeneralDisclosure24 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure24";
import GeneralDisclosure25 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure25";
import GeneralDisclosure28 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure28";
import GeneralDisclosure29 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure29";
import GeneralDisclosure210 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure210";
import GeneralDisclosure212 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure212";
import GeneralDisclosure213 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure213";
import GeneralDisclosure214 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure214";
import GeneralDisclosure215 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure215";
import GeneralDisclosure216 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure216";
import GeneralDisclosure217 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure217";
import GeneralDisclosure218 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure218";
import GeneralDisclosure219 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure219";
import GeneralDisclosure220 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure220";
import GeneralDisclosure221 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure221";
import GeneralDisclosure222 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure222";
import GeneralDisclosure223 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure223";
import GeneralDisclosure224 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure224";
import GeneralDisclosure225 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure225";
import GeneralDisclosure226 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure226";
import GeneralDisclosure227 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure227";
import GeneralDisclosure228 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure228";
import GeneralDisclosure229 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure229";
import GeneralDisclosure230 from "../Pages/GRI/GeneralDisclosure/GeneralDisclosure230";
import Economicperformance2011 from "../Pages/GRI/EconomicPerformance/GRI201/GRI201-1";
import Economicperformance2012 from "../Pages/GRI/EconomicPerformance/GRI201/GRI201-2";
import Economicperformance2013 from "../Pages/GRI/EconomicPerformance/GRI201/GRI201-3";
import Economicperformance2014 from "../Pages/GRI/EconomicPerformance/GRI201/GRI201-4";
import GRI202_1 from "../Pages/GRI/EconomicPerformance/GRI202/GRI202-1";
import GRI202_2 from "../Pages/GRI/EconomicPerformance/GRI202/GRI202-2";
import GRI204_1 from "../Pages/GRI/EconomicPerformance/GRI204/GRI204-1";
import GRI206_1 from "../Pages/GRI/EconomicPerformance/GRI206/GRI206-1";
import GRI207_1 from "../Pages/GRI/EconomicPerformance/GRI207/GRI207-1";
import GRI207_2 from "../Pages/GRI/EconomicPerformance/GRI207/GRI207-2";
import GRI207_3 from "../Pages/GRI/EconomicPerformance/GRI207/GRI207-3";
import GRI207_4 from "../Pages/GRI/EconomicPerformance/GRI207/GRI207-4";
import GRI203_1 from "../Pages/GRI/EconomicPerformance/GRI203/GRI203-1";
import GRI203_2 from "../Pages/GRI/EconomicPerformance/GRI203/GRI203-2";
import GRI205_1 from "../Pages/GRI/EconomicPerformance/GRI205/GRI205-1";
import GRI205_2 from "../Pages/GRI/EconomicPerformance/GRI205/GRI205-2";
import GRI205_3 from "../Pages/GRI/EconomicPerformance/GRI205/GRI205-3";
import GRI301_1 from "../Pages/GRI/GRI300/GRI301/GRI301-1";
import GRI301_2 from "../Pages/GRI/GRI300/GRI301/GRI301-2";
import GRI301_3 from "../Pages/GRI/GRI300/GRI301/GRI301-3";
import GRI302_1 from "../Pages/GRI/GRI300/GRI302/GRI302-1";
import GRI302_2 from "../Pages/GRI/GRI300/GRI302/GRI302-2";
import GRI302_3 from "../Pages/GRI/GRI300/GRI302/GRI302-3";
import GRI302_4 from "../Pages/GRI/GRI300/GRI302/GRI302-4";
import GRI302_5 from "../Pages/GRI/GRI300/GRI302/GRI302-5";

import GRI303_2 from "../Pages/GRI/GRI300/GRI303/GRI303-2";
import GRI303_5 from "../Pages/GRI/GRI300/GRI303/GRI303-5";
import GRI303_1 from "../Pages/GRI/GRI300/GRI303/GRI303-1";

import GRI306_1 from "../Pages/GRI/GRI300/GRI306/GRI306-1";
import GRI306_2 from "../Pages/GRI/GRI300/GRI306/GRI306-2";
import GRI306_3 from "../Pages/GRI/GRI300/GRI306/GRI306-3";
import GRI306_4 from "../Pages/GRI/GRI300/GRI306/GRI306-4";
import GRI306_5 from "../Pages/GRI/GRI300/GRI306/GRI306-5";
import GRI401_2 from "../Pages/GRI/GRI400/GRI401/GRI401-2";
import GRI401_3 from "../Pages/GRI/GRI400/GRI401/GRI401-3";
import GRI401_1 from "../Pages/GRI/GRI400/GRI401/GRI401-1";
import GRI402 from "../Pages/GRI/GRI400/GRI402";
import GRI403_1 from "../Pages/GRI/GRI400/GRI403/GRI403-1";
import GRI403_2 from "../Pages/GRI/GRI400/GRI403/GRI403-2";
import GRI403_3 from "../Pages/GRI/GRI400/GRI403/GRI403-3";
import GRI403_4 from "../Pages/GRI/GRI400/GRI403/GRI403-4";
import GRI403_5 from "../Pages/GRI/GRI400/GRI403/GRI403-5";
import GRI403_6 from "../Pages/GRI/GRI400/GRI403/GRI403-6";
import GRI403_7 from "../Pages/GRI/GRI400/GRI403/GRI403-7";
import GRI403_8 from "../Pages/GRI/GRI400/GRI403/GRI403-8";
import GRI403_9 from "../Pages/GRI/GRI400/GRI403/GRI403-9";
import GRI404_1 from "../Pages/GRI/GRI400/GRI404/GRI404-1";
import GRI404_2 from "../Pages/GRI/GRI400/GRI404/GRI404-2";
import GRI404_3 from "../Pages/GRI/GRI400/GRI404/GRI404-3";
import GRI405_1 from "../Pages/GRI/GRI400/GRI405/GRI405-1";
import GRI405_2 from "../Pages/GRI/GRI400/GRI405/GRI405-2";
import GRI406 from "../Pages/GRI/GRI400/GRI406";
import GRI407 from "../Pages/GRI/GRI400/GRI407";
import GRI408 from "../Pages/GRI/GRI400/GRI408";
import GRI409 from "../Pages/GRI/GRI400/GRI409";
import GRI410 from "../Pages/GRI/GRI400/GRI410";
import GRI411 from "../Pages/GRI/GRI400/GRI411";
import GRI413_1 from "../Pages/GRI/GRI400/GRI413/GRI413-1";
import GRI413_2 from "../Pages/GRI/GRI400/GRI413/GRI413-2";
import GRI414_1 from "../Pages/GRI/GRI400/GRI414/GRI414-1";
import GRI414_2 from "../Pages/GRI/GRI400/GRI414/GRI414-2";
import GRI415 from "../Pages/GRI/GRI400/GRI415";
import GRI416_1 from "../Pages/GRI/GRI400/GRI416/GRI416-1";
import GRI416_2 from "../Pages/GRI/GRI400/GRI416/GRI416-2";
import GRI418 from "../Pages/GRI/GRI400/GRI418";
import GRI417_1 from "../Pages/GRI/GRI400/GRI417/GRI417-1";
import GRI417_2 from "../Pages/GRI/GRI400/GRI417/GRI417-2";
import GRI417_3 from "../Pages/GRI/GRI400/GRI417/GRI417-3";
import GRI303_3 from "../Pages/GRI/GRI300/GRI303/GRI303-3";
import GRI303_4 from "../Pages/GRI/GRI300/GRI303/GRI303-4";
import GRI304_3 from "../Pages/GRI/GRI300/GRI304/GRI304-3";
import GRI304_2 from "../Pages/GRI/GRI300/GRI304/GRI304-2";
import GRI304_1 from "../Pages/GRI/GRI300/GRI304/GRI304-1";
import GRI304_4 from "../Pages/GRI/GRI300/GRI304/GRI304-4";
import GRI305_1 from "../Pages/GRI/GRI300/GRI305/GRI305-1";
import GRI403_10 from "../Pages/GRI/GRI400/GRI403/GRI403-10";
import GRI308_1 from "../Pages/GRI/GRI300/GRI308/GRI308-1";
import GRI308_2 from "../Pages/GRI/GRI300/GRI308/GRI308-2";

import GRI305_2 from "../Pages/GRI/GRI300/GRI305/GRI305-2";
import GRI305_3 from "../Pages/GRI/GRI300/GRI305/GRI305-3";
import GRI305_4 from "../Pages/GRI/GRI300/GRI305/GRI305-4";
import GRI305_7 from "../Pages/GRI/GRI300/GRI305/GRI305-7";
import GRI305_6 from "../Pages/GRI/GRI300/GRI305/GRI305-6";
import GRI305_5 from "../Pages/GRI/GRI300/GRI305/GRI305-5";
import GriList from "../Pages/GRI/List";
import GRIReview from "../Pages/GRI/GRI400/GRIReview";
import GRIDownload from "../Pages/GRI/GRIDownload";
import GRIDownloadPuppeteer from "../Pages/GRI/GRIDownload1";
import GRIReport from "../Pages/GRIReport/Report";

export const GRIRoutes = [
      { path:"/gri" ,element:<GriList />},
      {path:"/gri/general-disclosure/2-1/:id",element:<GeneralDisclosure21 />},
      {path:"/gri/general-disclosure/2-2/:id",element:<GeneralDisclosure22 />},
      {path:"/gri/general-disclosure/2-3/:id",element:<GeneralDisclosure23 />},
      {path:"/gri/general-disclosure/2-4/:id",element:<GeneralDisclosure24 />},
      {path:"/gri/general-disclosure/2-5/:id",element:<GeneralDisclosure25 />},
      {path:"/gri/general-disclosure/2-6/:id",element:<GeneralDisclosure26 />},
      {path:"/gri/general-disclosure/2-7/:id",element:<GeneralDisclosure27 />},
      {path:"/gri/general-disclosure/2-8/:id",element:<GeneralDisclosure28 />},
      {path:"/gri/general-disclosure/2-9/:id",element:<GeneralDisclosure29 />},
      {path:"/gri/general-disclosure/2-10/:id",element:<GeneralDisclosure210 />},
      {path:"/gri/general-disclosure/2-11/:id",element:<GeneralDisclosure211 />},
      {path:"/gri/general-disclosure/2-12/:id",element:<GeneralDisclosure212 />},
      {path:"/gri/general-disclosure/2-13/:id",element:<GeneralDisclosure213 />},
      {path:"/gri/general-disclosure/2-14/:id",element:<GeneralDisclosure214 />},
      {path:"/gri/general-disclosure/2-15/:id",element:<GeneralDisclosure215 />},
      {path:"/gri/general-disclosure/2-16/:id",element:<GeneralDisclosure216 />},
      {path:"/gri/general-disclosure/2-17/:id",element:<GeneralDisclosure217 />},
      {path:"/gri/general-disclosure/2-18/:id",element:<GeneralDisclosure218 />},
      {path:"/gri/general-disclosure/2-19/:id",element:<GeneralDisclosure219 />},
      {path:"/gri/general-disclosure/2-20/:id",element:<GeneralDisclosure220 />},
      {path:"/gri/general-disclosure/2-21/:id",element:<GeneralDisclosure221 />},
      {path:"/gri/general-disclosure/2-22/:id",element:<GeneralDisclosure222 />},
      {path:"/gri/general-disclosure/2-23/:id",element:<GeneralDisclosure223 />},
      {path:"/gri/general-disclosure/2-24/:id",element:<GeneralDisclosure224 />},
      {path:"/gri/general-disclosure/2-25/:id",element:<GeneralDisclosure225 />},
      {path:"/gri/general-disclosure/2-27/:id",element:<GeneralDisclosure227 />},
      {path:"/gri/general-disclosure/2-26/:id",element:<GeneralDisclosure226 />},
      {path:"/gri/general-disclosure/2-28/:id",element:<GeneralDisclosure228 />},
      {path:"/gri/general-disclosure/2-29/:id",element:<GeneralDisclosure229 />},
      {path:"/gri/general-disclosure/2-30/:id",element:<GeneralDisclosure230 />},
      {path:"/gri/economic-performance/201-1/:id",element:<Economicperformance2011 />},
      {path:"/gri/economic-performance/201-2/:id",element:<Economicperformance2012 />},
      {path:"/gri/economic-performance/201-3/:id",element:<Economicperformance2013 />},
      {path:"/gri/economic-performance/201-4/:id",element:<Economicperformance2014 />},

      {path:"/gri/economic-performance/202-1/:id", element:<GRI202_1 />},
      {path:"/gri/economic-performance/202-2/:id",element:<GRI202_2 />},
      {path:"/gri/economic-performance/204-1/:id",element:<GRI204_1 />},
      {path:"/gri/economic-performance/206-1/:id",element:<GRI206_1 />},
      {path:"/gri/economic-performance/207-1/:id",element:<GRI207_1 />},
      {path:"/gri/economic-performance/207-2/:id",element:<GRI207_2 />},
      {path:"/gri/economic-performance/207-3/:id",element:<GRI207_3 />},
      {path:"/gri/economic-performance/207-4/:id",element:<GRI207_4 />},
      {path:"/gri/economic-performance/203-1/:id",element:<GRI203_1 />},
      {path:"/gri/economic-performance/203-2/:id",element:<GRI203_2 />},
      {path:"/gri/economic-performance/205-1/:id",element:<GRI205_1 />},
      {path:"/gri/economic-performance/205-2/:id",element:<GRI205_2 />},
      {path:"/gri/economic-performance/205-3/:id",element:<GRI205_3 />},

      { path:"gri/gri300/301-1/:id" ,element:<GRI301_1 />},
      { path:"gri/gri300/301-2/:id" ,element:<GRI301_2 />},
      { path:"gri/gri300/301-3/:id" ,element:<GRI301_3 />},
      { path:"gri/gri300/302-1/:id" ,element:<GRI302_1 />},
      { path:"gri/gri300/302-2/:id" ,element:<GRI302_2 />},
      { path:"gri/gri300/302-3/:id" ,element:<GRI302_3 />},
      { path:"gri/gri300/302-4/:id" ,element:<GRI302_4 />} ,
      { path:"gri/gri300/302-5/:id" ,element:<GRI302_5 />} ,
      { path:"/gri/gri300/303-1/:id" ,element:<GRI303_1 />} ,
      { path:"/gri/gri300/303-2/:id" ,element:<GRI303_2 />} ,
      { path:"/gri/gri300/303-3/:id" ,element:<GRI303_3 />},
      { path:"/gri/gri300/303-4/:id" ,element:<GRI303_4 />},
      { path:"/gri/gri300/303-5/:id" ,element:<GRI303_5 />},

      { path:"/gri/gri300/305-1/:id" ,element:<GRI305_1 />},
      { path:"/gri/gri300/305-2/:id" ,element:<GRI305_2 />},
      { path:"/gri/gri300/305-3/:id" ,element:<GRI305_3 />},
      { path:"/gri/gri300/305-4/:id" ,element:<GRI305_4 />},
      { path:"/gri/gri300/305-5/:id" ,element:<GRI305_5 />},
      { path:"/gri/gri300/305-6/:id" ,element:<GRI305_6 />},
      { path:"/gri/gri300/305-7/:id" ,element:<GRI305_7 />},

      { path:"/gri/gri300/306-1/:id" ,element:<GRI306_1 />},
      { path:"/gri/gri300/306-2/:id" ,element:<GRI306_2 />},
      { path:"/gri/gri300/306-3/:id" ,element:<GRI306_3 />},
      { path:"/gri/gri300/306-4/:id" ,element:<GRI306_4 />},
      { path:"/gri/gri300/306-5/:id" ,element:<GRI306_5 />},

      { path:"/gri/gri300/304-1/:id" ,element:<GRI304_1 />},
      { path:"/gri/gri300/304-2/:id" ,element:<GRI304_2 />},
      { path:"/gri/gri300/304-3/:id" ,element:<GRI304_3 />},
      { path:"/gri/gri300/304-4/:id" ,element:<GRI304_4 />},
      { path:"/gri/gri300/305-1/:id" ,element:<GRI305_1 />},
      { path:"/gri/gri300/308-1/:id" ,element:<GRI308_1 />},
      { path:"/gri/gri300/308-2/:id" ,element:<GRI308_2 />},
      
      { path:"/gri/gri400/401-1/:id", element:<GRI401_1 />},
      { path:"/gri/gri400/401-2/:id" ,element:<GRI401_2 />},
      { path:"/gri/gri400/401-3/:id" ,element:<GRI401_3 />},
      { path:"/gri/gri400/402-1/:id", element:<GRI402 />},
      { path:"/gri/gri400/403-1/:id", element:<GRI403_1 />},
      { path:"/gri/gri400/403-2/:id" ,element:<GRI403_2 />},
      { path:"/gri/gri400/403-3/:id" ,element:<GRI403_3 />},
      { path:"/gri/gri400/403-4/:id" ,element:<GRI403_4 />},
      { path:"/gri/gri400/403-5/:id" ,element:<GRI403_5 />},
      { path:"/gri/gri400/403-6/:id" ,element:<GRI403_6 />},
      { path:"/gri/gri400/403-7/:id" ,element:<GRI403_7 />},
      { path:"/gri/gri400/403-8/:id" ,element:<GRI403_8 />},
      { path:"/gri/gri400/403-9/:id" ,element:<GRI403_9 />},
      { path:"/gri/gri400/404-1/:id" ,element:<GRI404_1 />},
      { path:"/gri/gri400/404-2/:id" ,element:<GRI404_2 />},
      { path:"/gri/gri400/404-3/:id" ,element:<GRI404_3 />},
      { path:"/gri/gri400/406-1/:id" ,element:<GRI406 />},
      { path:"/gri/gri400/407-1/:id" ,element:<GRI407 />},
      { path:"/gri/gri400/408-1/:id" ,element:<GRI408 />},
      { path:"/gri/gri400/409-1/:id" ,element:<GRI409 />},
      { path:"/gri/gri400/410-1/:id" ,element:<GRI410 />},
      { path:"/gri/gri400/411-1/:id" ,element:<GRI411 />},
      { path:"/gri/gri400/413-1/:id" ,element:<GRI413_1 />},
      { path:"/gri/gri400/413-2/:id" ,element:<GRI413_2 />},
      { path:"/gri/gri400/414-1/:id", element:<GRI414_1 />},
      { path:"/gri/gri400/414-2/:id" ,element:<GRI414_2 />},
      { path:"/gri/gri400/415-1/:id" ,element:<GRI415 />},
      { path:"/gri/gri400/416-1/:id" ,element:<GRI416_1 />},
      { path:"/gri/gri400/416-2/:id" ,element:<GRI416_2 />},
      { path:"/gri/gri400/418-1/:id", element:<GRI418 />},
      { path:"/gri/gri400/417-1/:id", element:<GRI417_1 />},
      { path:"/gri/gri400/417-2/:id", element:<GRI417_2 />},
      { path:"/gri/gri400/417-3/:id", element:<GRI417_3 />},
      { path:"/gri/gri400/405-1/:id", element:<GRI405_1 />},
      { path:"/gri/gri400/405-2/:id", element:<GRI405_2 />},
      { path:"/gri/gri400/403-10/:id", element:<GRI403_10 />},
      { path:"/gri/review/:id", element:<GRIReview />},
      { path:"/gri/preview/:id", element:<GRIDownloadPuppeteer />},
      { path:"/gri/preview-download/:id", element:<GRIReport />},


 ]
